"use client";
import { Box } from "../../../core/Box/Box.mjs";
import Loader_module_default from "../Loader.module.mjs";
import cx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Loader/loaders/Dots.tsx
const Dots = ({ className, ...others }) => /* @__PURE__ */ jsxs(Box, {
	component: "span",
	className: cx(Loader_module_default.dotsLoader, className),
	...others,
	children: [
		/* @__PURE__ */ jsx("span", { className: Loader_module_default.dot }),
		/* @__PURE__ */ jsx("span", { className: Loader_module_default.dot }),
		/* @__PURE__ */ jsx("span", { className: Loader_module_default.dot })
	]
});
Dots.displayName = "@mantine/core/Dots";
//#endregion
export { Dots };

//# sourceMappingURL=Dots.mjs.map